import {Filters} from "../../models/Filter"
import {isFilterFacet} from "../../models/Filter/typeGuards"

interface Params {
    oldFilters: Filters
    newFilters: Filters
    selectedFilter: string
}

export const setFacetsOriginalOrder = ({oldFilters, newFilters, selectedFilter}: Params) => {
    const filters = {...newFilters}
    const filter = filters[selectedFilter]

    const oldFiltersCopy = {...oldFilters}
    const oldFilter = oldFiltersCopy[selectedFilter]

    if (!isFilterFacet(filter)) return newFilters
    if (!isFilterFacet(oldFilter)) return oldFilters

    const refObj = {}
    const {facets: refFacets} = oldFilter
    for (let f = 0; f < refFacets.length; f += 1) {
        refObj[refFacets[f]] = f
    }

    const {facets: newFacets} = filter
    const newFacetsArray = [...newFacets]

    newFacetsArray.sort((a, b) => {
        return refObj[a] - refObj[b]
    })

    const finalFilters = filter
    finalFilters.facets = newFacetsArray
    filters[selectedFilter] = finalFilters
    return filters
}
